import { NotebookEngine_FailureReason } from '../gen/ai/h2o/engine/v1/notebook_engine_pb';

export const notebookEngineFailReason: Record<NotebookEngine_FailureReason, string> = {
  [NotebookEngine_FailureReason.UNSPECIFIED]: 'Unspecified',
  [NotebookEngine_FailureReason.UNKNOWN]: 'Unknown',
  [NotebookEngine_FailureReason.OOM_KILLED]: 'OOM Killed',
  [NotebookEngine_FailureReason.PROCESS_FAILED]: 'Process Failed',
  [NotebookEngine_FailureReason.PVC_ACCESS_FAILURE]: 'PVC Access Failed',
};
